<script lang="ts">
  export let orientation: 'horizontal' | 'vertical' = 'horizontal'
  export let role: 'separator' | 'presentation' = 'separator'
  export let label: string | undefined = undefined
</script>

{#if label}
  <div class="label-container">
    <hr aria-orientation="horizontal" {role} />
    <div class="label">{label}</div>
    <hr aria-orientation="horizontal" {role} />
  </div>
{:else}
  <hr aria-orientation={orientation} {role} />
{/if}

<style lang="scss">
  .label-container {
    display: flex;
    align-items: center;
    gap: 0.5em;
    margin: 1em 0;
    width: 100%;

    .label {
      opacity: 0.5;
    }
  }

  hr {
    display: block;
    border-width: var(--divider-thickness, thin) 0 0 0;
    border-style: solid;
    height: 0;
    opacity: var(--divider-opacity, 0.12);
    border-color: var(--color-on-surface);
    width: 100%;
    margin: var(--divider-margin, revert);

    &[aria-orientation='vertical'] {
      align-self: stretch;
      border-width: 0 var(--divider-thickness, thin) 0 0;
      display: inline-flex;
      height: inherit;
      margin-left: -1px;
      margin-right: -1px;
      max-height: 100%;
      max-width: 0px;
      vertical-align: text-bottom;
      width: 0px;
    }
  }
</style>
